import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import CardAssignment from "../../components/Card/CardAssignment";
import SearchBar from "../../components/Searchbar";
import { getTeachingTask } from "../../redux/actions/teaching";
import { IoFilterOutline } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
// import { Card } from "reactstrap";
import {
  ArchiveDiv,
  ActiveDiv,
  Card,
  SideBarActiveDiv,
  SideBarNormalDiv,
  SideBarActiveDivButton,
  SideBarNormalDivButton,
  ButtonCommonTop,
  SideBarActiveDivNew,
  SideBarNormalDivNew,
  SideBarActiveDivButtonNew,
  SideBarNormalDivButtonNew,
  SideBarNormalCount,
  SideBarActiveCount,
} from "../Theme";
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";
import { MdOutlinePeopleAlt } from "react-icons/md";
import { IoMdArchive } from "react-icons/io";
import { SetMealSharp } from "@mui/icons-material";
import { GET_TEACHING_DETAILS } from "../../redux/actions";

export default function DPTask() {
  const rawData = useSelector((state) => state.teaching.taskList.message);
  const [teachingTask, setTeachingTask] = useState([]);
  const [filteredTaskList, setFilteredTaskList] = useState([]);
  const [filteredPinList, setFilteredPinList] = useState([]);
  const [filteredArchiveList, setFilteredArchiveList] = useState([]);
  const [searchField, setSearchField] = useState("");
  const [searchedTask, setSearchedTask] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("-1");
  const [courseOptions, setCourseOptions] = useState([]);
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  const [show, setShow] = useState(true);
  const [sidebar, setSidebar] = useState(false);
  const [pinnedAssignments, setPinnedAssignments] = useState([]);
  const [pinnedShow, setpinnedShow] = useState(true);
  const [pinnedSidebar, setpinnedSidebar] = useState(false);
  const [selectedPinOption, setSelectedPinOption] = useState("-1");
  const [isActive, setIsActive] = useState(true);
  const [currentText, setCurrentText] = useState("Active");
  const [clearInput, setclearInput] = useState(false);
  const [isPinnedStatus, setisPinnedStatus] = useState(false);
  const [intakeSidebar, setintakeSidebar] = useState([]);
  const [intakeShow, setintakeShow] = useState(true);
  const [selectedIntake, setSelectedIntake] = useState("");
  const [isIntakeStatus, setIsIntakeStatus] = useState(false);
  useEffect(() => {
    dispatch({ type: GET_TEACHING_DETAILS, payload: null });
  }, []);
  const ToggleView = ({ text, active, icon, ...props }) => {
    const handleActive = () => {
      if (currentText != text) {
        setIsActive(!isActive);
        setCurrentText(text);
      }
    };
    let styles =
      "h-full flex items-center rounded-full px-6 md:px-8 md:mr-8 cursor-pointer";
    return active ? (
      <ButtonCommonTop className={styles} onClick={() => handleActive(text)}>
        {icon}
        {text}
      </ButtonCommonTop>
    ) : (
      <ArchiveDiv className={styles} onClick={() => handleActive(text)}>
        {icon}
        {text}
      </ArchiveDiv>
    );
  };

  const Tab = ({ text, active, onClick, ...props }) => {
    let style = "font-14px font-medium cursor-pointer hover:text-blue-500";
    return active ? (
      <SideBarActiveDiv className={style}>{text}</SideBarActiveDiv>
    ) : (
      <SideBarNormalDiv className={style}>{text}</SideBarNormalDiv>
    );
  };

  const showSidebar = () => {
    setShow(!show);
    setSidebar(!sidebar);
    setSelectedCourse("-1");
    setSelectedPinOption("-1");
    setisPinnedStatus(false);
    setSelectedIntake("");
  };
  const showPinnedSidebar = () => {
    setpinnedShow(!pinnedShow);
    setpinnedSidebar(!pinnedSidebar);
    setSelectedPinOption("");
    setSelectedCourse("-1");
    setisPinnedStatus(true);
    setSelectedIntake("");
  };
  const showIntakeSidebar = () => {
    setintakeShow(!intakeShow);
    setSelectedIntake("-1");
    setSelectedPinOption("-1");
    setSelectedCourse("-1");
  };

  useEffect(() => {
    let selectedTasks = [];
    if (selectedPinOption === "") {
      if (selectedCourse === "-1") {
        selectedTasks = teachingTask.filter(
          (task) => task[1].is_pinned === true
        );
      } else {
        selectedTasks = teachingTask.filter(
          (task) =>
            selectedCourse === task[1].group_name && task[1].is_pinned === true
        );
      }
    } else if (selectedPinOption === "-1") {
      if (selectedCourse === "-1") {
        selectedTasks = teachingTask.filter((task) =>
          selectedPinOption === "-1"
            ? true
            : selectedPinOption === task[1].group_name
        );
      } else {
        selectedTasks = teachingTask.filter((task) =>
          selectedPinOption === "-1"
            ? selectedCourse === task[1].group_name
            : selectedPinOption === task[1].group_name
        );
      }
    } else {
      if (selectedCourse === "-1") {
        selectedTasks = teachingTask.filter(
          (task) =>
            selectedPinOption === task[1].group_name &&
            task[1].is_pinned === true
        );
      } else {
        selectedTasks = teachingTask.filter(
          (task) =>
            selectedPinOption === task[1].group_name &&
            selectedCourse === task[1].group_name &&
            task[1].is_pinned === true
        );
      }
    }

    if (selectedIntake === "") {
      setFilteredTaskList(filterBy(selectedTasks));
    } else if (selectedIntake === "-1") {
      let newSelectedValue = selectedTasks.filter(
        (data, index) => data[1].intake !== null
      );
      setFilteredTaskList(filterBy(newSelectedValue));
    } else if (selectedIntake != "-1" && selectedIntake !== "") {
      let newSelectedValue = selectedTasks.filter(
        (data, index) => data[1].intake === selectedIntake
      );
      setFilteredTaskList(filterBy(newSelectedValue));
    }
  }, [
    teachingTask,
    selectedPinOption,
    selectedCourse,
    isActive,
    searchField,
    selectedIntake,
  ]);

  const [pinnedSidebarOptions, setPinnedSidebarOptions] = useState([]);
  const [sidebarGroups, setSideBargroups] = useState([]);
  const [intakeSidebarOptions, setIntakeSidebarOptions] = useState([]);

  // useEffect(() => {
  //   if (selectedIntake === "-1") {
  //     let selectedTasks = teachingTask.filter((data, index) => (data[1].intake !== null && data[1].is_archived === !isActive));
  //     setFilteredTaskList(filterBy(selectedTasks));
  //     setSelectedCourse("-1");
  //     setSelectedPinOption("-1");
  //   }
  //   else if (selectedIntake !== "" && selectedIntake !== "-1") {
  //     let selectedTasks = teachingTask.filter((data, index) => (data[1].intake === selectedIntake && data[1].is_archived === !isActive));
  //     setFilteredTaskList(filterBy(selectedTasks));
  //     setSelectedCourse("-1");
  //     setSelectedPinOption("-1");
  //   }

  // }, [selectedIntake, isActive])

  useEffect(() => {
    let options = [],
      optionIds = [];
    let inoptions = [],
      inoptionIds = [];

    const groupMap = {};
    teachingTask.forEach(([key, obj]) => {
      const { group_name, group_id, is_archived } = obj;
      if (group_name) {
        if (is_archived === !isActive) {
          if (!groupMap[group_name]) {
            groupMap[group_name] = {
              value: group_name,
              id: group_id,
              count: 1,
            };
          } else {
            groupMap[group_name].count += 1;
          }
        }
      }
    });
    const groupedArray = Object.values(groupMap).sort((a, b) =>
      String(a?.value ?? "").localeCompare(String(b?.value ?? ""))
    );
    setSideBargroups(groupedArray);

    const groupMapPinned = {};
    teachingTask.forEach(([key, obj]) => {
      const { group_name, group_id, is_archived, is_pinned } = obj;
      if (group_name) {
        if (is_archived === !isActive && is_pinned == true) {
          if (!groupMapPinned[group_name]) {
            groupMapPinned[group_name] = {
              value: group_name,
              id: group_id,
              count: 1,
            };
          } else {
            groupMapPinned[group_name].count += 1;
          }
        }
      }
    });
    const groupedArrayPinned = Object.values(groupMapPinned).sort((a, b) =>
      String(a?.value ?? "").localeCompare(String(b?.value ?? ""))
    );
    setPinnedSidebarOptions(groupedArrayPinned);

    teachingTask.forEach((task) => {
      if (
        task[1].group_name &&
        !optionIds.includes(task[1].group_name) &&
        task[1]?.is_archived === !isActive
      ) {
        optionIds.push(task[1].group_name);
        options.push({
          value: task[1].group_name,
          id: task[1].group_id,
        });
      }
    });
    teachingTask.forEach((task) => {
      if (
        task[1].intake &&
        !inoptionIds.includes(task[1].intake) &&
        task[1]?.is_archived === !isActive
      ) {
        inoptionIds.push(task[1].intake);
        inoptions.push({
          value: task[1].intake,
          id: task[1].intake,
        });
      }
    });

    const intakeMapPinned = {};

    teachingTask.forEach(([key, obj]) => {
      const { intake, group_id, is_archived } = obj;
      if (intake) {
        // Only include items matching your condition
        if (is_archived === !isActive) {
          if (!intakeMapPinned[intake]) {
            intakeMapPinned[intake] = {
              value: intake, // use intake as value
              id: intake, // if you want a representative id; may choose first occurrence
              count: 1,
            };
          } else {
            intakeMapPinned[intake].count += 1;
          }
        }
      }
    });

    const groupedArrayByIntake = Object.values(intakeMapPinned).sort((a, b) =>
      String(a?.value ?? "").localeCompare(String(b?.value ?? ""))
    );
    setIntakeSidebarOptions(groupedArrayByIntake);

    setintakeSidebar(
      [...inoptions].sort((a, b) => {
        if (a.value < b.value) {
          return -1;
        } else if (a.value > b.value) {
          return 1;
        } else {
          return 0;
        }
      })
    );
    const sortedOptions = [...options].sort((a, b) => {
      if (a.value < b.value) return -1;
      if (a.value > b.value) return 1;
      return 0;
    });
    setCourseOptions(sortedOptions);
  }, [isActive, teachingTask]);

  function filterBy(oldArray) {
    if (searchField.length === 0) {
      return oldArray;
    } else {
      oldArray.forEach((data) => {
        if (data[1].group_name === null) {
          data[1].group_name = "";
        }
        if (data[1].list_name === null) {
          data[1].list_name = "";
        }
      });
      let newArray = oldArray.filter(
        (taskList) =>
          taskList[1]?.list_name
            .toString()
            .toLowerCase()
            .includes(searchField.toLowerCase()) ||
          taskList[1]?.group_name
            .toString()
            .toLowerCase()
            .includes(searchField.toLowerCase())
      );
      return newArray;
    }
  }

  useEffect(() => {
    dispatch(getTeachingTask());
  }, []);

  useEffect(() => {
    if (rawData) {
      setTeachingTask(Object.entries(rawData));
    }
  }, [rawData]);

  useEffect(() => {
    setSelectedCourse("-1");
    setSelectedPinOption("-1");
    setclearInput(!clearInput);
    setSearchField("");
    setShow(true);
    setpinnedShow(false);
    setpinnedSidebar(false);
    setSidebar(false);
    setisPinnedStatus(false);
    setintakeShow(true);
    setSelectedIntake("");
  }, [isActive]);

  return (
    <div className="flex flex-col md:flex-col lg:flex-row ">
      <div className="flex flex-row-reverse lg:flex-col border-right-f1">
        <div className="px-4 w-full border-bottom-f1 pt-4 pb-3 md:pt-6 md:pb-6 box-border">
          <SearchBar setSearchField={setSearchField} clear={clearInput} />
        </div>
        <div className="lg:w-64 md:top-32 flex flex-row lg:flex-col-reverse">
          <div className="lg:hidden border-bottom-f1 flex items-center">
            <div className="bg-white flex items-center h-12 pl-10 pr-4 mr-4">
              <IoFilterOutline
                className="w-6 h-6 cursor-pointer"
                onClick={() => setModal(true)}
              />
            </div>
          </div>
          <Card
            className={
              modal
                ? `inline-block lg:bg-white lg:bg-opacity-100 
                                 lg:mt-0 bg-black bg-opacity-60 w-full h-[calc(100vh-88px)]  
                                overflow-auto lg:pr-20 fixed topbar-offset lg:relative z-50 pr-16 `
                : `hidden lg:inline-block lg:bg-opacity-100 
                                mt-20 lg:mt-0 lg:rounded-lg 
                                 fixed top-0 lg:relative z-10 pb-6`
            }
            // style={{ height: "100%" }}
          >
            <div
              className="flex pt-5 pb-3 pl-2 lg:pt-0 lg:mt-3  pr-2 items-center cursor-pointer border-bottom-f1"
              onClick={() => {
                setSelectedCourse("-1");
                setSelectedPinOption("-1");
                setisPinnedStatus(false);
                setSelectedIntake("");
              }}
            >
              {selectedCourse === "-1" &&
              selectedPinOption == "-1" &&
              isPinnedStatus == false &&
              selectedIntake == "" ? (
                <SideBarActiveDivNew
                  className={`font-14px font-bold cursor-pointer w-full py-1 pl-2 r`}
                >
                  All tasks
                </SideBarActiveDivNew>
              ) : (
                <SideBarNormalDivNew
                  className={`font-14px font-bold cursor-pointer w-full py-1 pl-2 `}
                >
                  All tasks
                </SideBarNormalDivNew>
              )}
            </div>
            <div className="w-full px-4">
              <div className={` border-bottom-f1 pb-3 pt-3`}>
                <div
                  className="flex  items-center justify-between cursor-pointer"
                  onClick={() => {
                    setpinnedShow(!pinnedShow);
                  }}
                >
                  <Tab
                    text="Pinned"
                    active={pinnedSidebarOptions.some(
                      (item1) => item1.value === selectedPinOption
                    )}
                  />
                  {!pinnedShow ? (
                    <MdKeyboardArrowDown className="blueColor" size={20} />
                  ) : (
                    <MdKeyboardArrowRight className="blueColor" size={20} />
                  )}
                </div>
                <div
                  className={
                    pinnedShow
                      ? "hidden"
                      : "flex flex-col flex-1 border-left-f1 ml-1 pl-2"
                  }
                >
                  {pinnedSidebarOptions.length > 0 ? (
                    pinnedSidebarOptions?.map((data, index) =>
                      // filteredTaskList?.filter(
                      //   (task) =>
                      //     task[1]?.group_name === data?.value &&
                      //     task[1]?.is_archived === !isActive &&
                      //     task[1]?.is_pinned === true
                      // )?.length > 0 &&
                      selectedPinOption === data?.value ? (
                        <SideBarActiveDivButtonNew
                          type="button"
                          className={`font-14px flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                          key={index}
                          value={data?.value}
                          onClick={(e) => {
                            setSelectedCourse("-1");
                            setSelectedIntake("");
                            setSelectedPinOption(data?.value);
                            setisPinnedStatus(true);
                          }}
                        >
                          {data?.value ?? "\u00A0"}
                          <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                            {/* {
                            filteredTaskList?.filter(
                              (task) =>
                                task[1]?.group_name === data?.value &&
                                task[1]?.is_archived === !isActive &&
                                task[1]?.is_pinned === true
                            )?.length
                          } */}
                            {data.count}
                          </SideBarActiveCount>
                        </SideBarActiveDivButtonNew>
                      ) : (
                        // filteredTaskList?.filter(
                        //   (task) =>
                        //     task[1]?.group_name === data?.value &&
                        //     task[1]?.is_archived === !isActive &&
                        //     task[1]?.is_pinned === true
                        // )?.length > 0 &&
                        <SideBarNormalDivButtonNew
                          type="button"
                          className={`font-14px flex items-center justify-between text-left lightColor whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                          key={index}
                          value={data?.value}
                          onClick={(e) => {
                            setSelectedCourse("-1");
                            setSelectedIntake("");
                            setSelectedPinOption(data?.value);
                            setisPinnedStatus(true);
                          }}
                        >
                          {data?.value ?? "\u00A0"}
                          <SideBarNormalCount className="inline-flex flex-shrink-0items-center justify-center p-1 text-center text-xs w-6 h-6">
                            {/* {
                            filteredTaskList?.filter(
                              (task) =>
                                task[1]?.group_name === data?.value &&
                                task[1]?.is_archived === !isActive &&
                                task[1]?.is_pinned === true
                            )?.length
                          } */}
                            {data.count}
                          </SideBarNormalCount>
                        </SideBarNormalDivButtonNew>
                      )
                    )
                  ) : (
                    <span className="flex items-center py-2 text-sm greyColor">
                      No Items
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="w-full px-4">
              <div className={`border-bottom-f1 pb-3 pt-3`}>
                <div
                  className="flex  items-center justify-between cursor-pointer"
                  onClick={() => {
                    setintakeShow(!intakeShow);
                  }}
                >
                  <Tab
                    text="Intake"
                    active={intakeSidebarOptions.some(
                      (item1) => item1.id === selectedIntake
                    )}
                  />
                  {!intakeShow ? (
                    <MdKeyboardArrowDown className="blueColor" size={20} />
                  ) : (
                    <MdKeyboardArrowRight className="blueColor" size={20} />
                  )}
                </div>
                <div
                  className={
                    intakeShow
                      ? "hidden"
                      : "flex flex-col flex-1 mt-2 border-left-f1 ml-1 pl-2"
                  }
                >
                  {intakeSidebarOptions.length > 0 ? (
                    intakeSidebarOptions.map((data, index) =>
                      // filteredTaskList?.filter(
                      //   (task) =>
                      //     task[1]?.intake === data?.value &&
                      //     task[1]?.is_archived === !isActive
                      // )?.length > 0 &&
                      selectedIntake === data.id ? (
                        <SideBarActiveDivButtonNew
                          type="button"
                          className={`font-14px flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                          key={index}
                          value={data?.id}
                          onClick={(e) => {
                            setSelectedCourse("-1");
                            setSelectedPinOption("-1");
                            setisPinnedStatus(false);
                            setSelectedIntake(data?.id);
                          }}
                        >
                          {data?.value ?? "\u00A0"}
                          <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                            {/* {
                            filteredTaskList.filter(
                              (val, index) =>
                                data?.value === val[1]?.intake &&
                                val[1]?.is_archived === !isActive
                            ).length
                          } */}
                            {data?.count}
                          </SideBarActiveCount>
                        </SideBarActiveDivButtonNew>
                      ) : (
                        // filteredTaskList?.filter(
                        //   (task) =>
                        //     task[1]?.intake === data?.value &&
                        //     task[1]?.is_archived === !isActive
                        // )?.length > 0 &&
                        <SideBarNormalDivButtonNew
                          type="button"
                          className={`font-14px flex items-center justify-between text-left lightColor whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                          key={index}
                          value={data?.id}
                          onClick={(e) => {
                            setSelectedCourse("-1");
                            setSelectedPinOption("-1");
                            setisPinnedStatus(false);
                            setSelectedIntake(data?.id);
                          }}
                        >
                          {data?.value ?? "\u00A0"}
                          <SideBarNormalCount className="inline-flex flex-shrink-0items-center justify-center p-1 text-center text-xs w-6 h-6">
                            {/* {
                            filteredTaskList.filter(
                              (val, index) =>
                                data?.value === val[1]?.intake &&
                                val[1]?.is_archived === !isActive
                            ).length
                          } */}
                            {data?.count}
                          </SideBarNormalCount>
                        </SideBarNormalDivButtonNew>
                      )
                    )
                  ) : (
                    <>
                      <span className="flex items-center py-2 text-sm greyColor">
                        No Items
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
            <div className="w-full px-4">
              <div className={`  pb-3 pt-3`}>
                <div
                  className="flex  items-center justify-between cursor-pointer"
                  onClick={() => {
                    setShow(!show);
                  }}
                >
                  <Tab
                    text="Groups"
                    active={sidebarGroups.some(
                      (item1) => item1.value === selectedCourse
                    )}
                  />
                  {!show ? (
                    <MdKeyboardArrowDown className="blueColor" size={20} />
                  ) : (
                    <MdKeyboardArrowRight className="blueColor" size={20} />
                  )}
                </div>
                <div
                  className={
                    show
                      ? "hidden"
                      : "flex flex-col flex-1 mt-2 border-left-f1 ml-1 pl-2"
                  }
                >
                  {sidebarGroups.length > 0 ? (
                    sidebarGroups?.map((data, index) => {
                      // const count =
                      //   selectedPinOption !== "" && !isPinnedStatus
                      //     ? teachingTask?.filter(
                      //         (task) =>
                      //           task[1]?.group_name === data?.value &&
                      //           task[1]?.is_archived === !isActive
                      //       )?.length
                      //     : filteredTaskList?.filter(
                      //         (task) =>
                      //           task[1]?.group_name === data?.value &&
                      //           task[1]?.is_archived === !isActive
                      //       )?.length;

                      // if (count === 0) return null;
                      return selectedCourse === data?.value ? (
                        <SideBarActiveDivButtonNew
                          type="button"
                          className={`font-14px flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                          key={index}
                          value={data?.value}
                          onClick={(e) => {
                            setSelectedPinOption("-1");
                            setisPinnedStatus(false);
                            setSelectedIntake("");
                            setSelectedCourse(data?.value);
                          }}
                        >
                          {data?.value ?? "\u00A0"}
                          <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                            {data?.count}
                          </SideBarActiveCount>
                        </SideBarActiveDivButtonNew>
                      ) : (
                        <SideBarNormalDivButtonNew
                          type="button"
                          className={`font-14px flex items-center justify-between text-left whitespace-normal py-1 lightColor my-1 pl-2 pr-2 w-full cursor-pointer font-medium`}
                          key={index}
                          value={data?.value}
                          onClick={(e) => {
                            setSelectedPinOption("-1");
                            setisPinnedStatus(false);
                            setSelectedIntake("");
                            setSelectedCourse(data?.value);
                          }}
                        >
                          {data?.value ?? "\u00A0"}
                          <SideBarNormalCount className="inline-flex flex-shrink-0items-center justify-center p-1 text-center text-xs w-6 h-6">
                            {data?.count}
                          </SideBarNormalCount>
                        </SideBarNormalDivButtonNew>
                      );
                    })
                  ) : (
                    <span className="flex items-center py-2 text-sm greyColor">
                      No Items
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div
              className="absolute top-5 right-10 lg:hidden text-gray-400 cursor-pointer"
              onClick={() => setModal(false)}
            >
              <IoCloseOutline className="w-8 h-8" />
            </div>
          </Card>
        </div>
      </div>
      <div className="w-full backGroundColor border20pxbottomright lg:rounded-bl-none rounded-bl-2xl">
        {/* <div>
          <div className="h-12 flex justify-evenly md:justify-start mb-4">
            <ToggleView
              active={isActive}
              text={"Active"}
              icon={<MdOutlinePeopleAlt className="w-5 h-5 mr-2" />}
            />
            <ToggleView
              active={!isActive}
              text={"Archive"}
              icon={<IoMdArchive className="w-5 h-5 mr-2" />}
            />
          </div>
        </div> */}
        {
          <>
            {filteredTaskList.length > 0 &&
              filteredTaskList.filter(
                (task) =>
                  task[1].is_archived === !isActive &&
                  task[1].is_pinned === true
              ).length > 0 && (
                <div>
                  {filteredTaskList.filter(
                    (task) =>
                      task[1].is_archived === !isActive &&
                      task[1].is_pinned === true
                  ).length > 0 && (
                    <div className="flex py-8 px-5 items-center justify-between cardBackgroundColor">
                      <span className="flex items-center gap-2 md:ml-1">
                        Pinned
                        <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                          {
                            filteredTaskList.filter(
                              (task) =>
                                task[1].is_archived === !isActive &&
                                task[1].is_pinned === true
                            ).length
                          }
                        </SideBarActiveCount>
                      </span>
                      <div className="flex items-center gap-3 md:mr-1">
                        <input
                          type="checkbox"
                          className="cursor-pointer w-4 h-4 checkBoxCustom"
                          checked={isActive}
                          onChange={() => {
                            setIsActive(true);
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        />
                        <span className="font-normal text-base greyColor">
                          Active
                        </span>
                        <input
                          type="checkbox"
                          className=" cursor-pointer w-4 h-4 checkBoxCustom"
                          checked={!isActive}
                          onChange={() => {
                            setIsActive(false);
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        />
                        <span className="font-normal text-base greyColor">
                          Archive
                        </span>
                      </div>
                    </div>
                  )}
                  {/* <div className="border-t border-gray-500 w-auto" /> */}
                  <div className="grid p-2 md:p-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-5">
                    {filteredTaskList.map(
                      (task, idx) =>
                        task[1].is_archived === !isActive &&
                        task[1].is_pinned === true && (
                          <Link
                            key={idx}
                            className="hover:no-underline flex"
                            to={{
                              pathname: `/teaching/detail/${task[0]}`,
                            }}
                          >
                            <CardAssignment
                              key={idx}
                              id={task[0]}
                              course={task[1].group_name}
                              title={task[1].list_name}
                              assigned={task[1].list_created}
                              due={task[1].list_due}
                              task={task[1].tasks_count}
                              participants={task[1].total_participant}
                              submissions={task[1].submissions}
                              notification={task[1].notification_count}
                              data={task}
                            />
                          </Link>
                        )
                    )}
                  </div>
                </div>
              )}
            {filteredTaskList.length > 0 && (
              <div>
                {filteredTaskList.filter(
                  (task) =>
                    task[1].is_archived === !isActive &&
                    task[1].is_pinned === false
                ).length > 0 && (
                  <>
                    <div className="flex py-8 px-5 cardBackgroundColor items-center justify-between">
                      <span className="flex items-center gap-2 md:ml-1">
                        Assignments
                        <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-6 h-6">
                          {
                            filteredTaskList.filter(
                              (task) =>
                                task[1].is_archived === !isActive &&
                                task[1].is_pinned === false
                            ).length
                          }
                        </SideBarActiveCount>
                      </span>
                      {filteredTaskList.filter(
                        (task) =>
                          task[1].is_archived === !isActive &&
                          task[1].is_pinned === true
                      ).length <= 0 && (
                        <div className="flex items-center gap-3 md:mr-1">
                          <input
                            type="checkbox"
                            className="cursor-pointer w-4 h-4 checkBoxCustom"
                            checked={isActive}
                            onChange={() => {
                              setIsActive(true);
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          />
                          <span className="font-normal text-base greyColor">
                            Active
                          </span>
                          <input
                            type="checkbox"
                            className=" cursor-pointer w-4 h-4 checkBoxCustom"
                            checked={!isActive}
                            onChange={() => {
                              setIsActive(false);
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          />
                          <span className="font-normal text-base greyColor">
                            Archive
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="grid p-2 md:p-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-5">
                      {filteredTaskList.map(
                        (task, idx) =>
                          task[1].is_archived === !isActive &&
                          task[1].is_pinned === false && (
                            <Link
                              key={idx}
                              className="hover:no-underline flex"
                              to={{
                                pathname: `/teaching/detail/${task[0]}`,
                              }}
                            >
                              <CardAssignment
                                key={idx}
                                id={task[0]}
                                course={task[1].group_name}
                                title={task[1].list_name}
                                assigned={task[1].list_created}
                                due={task[1].list_due}
                                task={task[1].tasks_count}
                                participants={task[1].total_participant}
                                submissions={task[1].submissions}
                                notification={task[1].notification_count}
                                data={task}
                              />
                            </Link>
                          )
                      )}
                    </div>
                  </>
                )}
              </div>
            )}
            {filteredTaskList.filter((task) => task[1].is_archived === false)
              .length == 0 &&
              isActive && (
                <div>
                  <div className="flex py-8 px-6 cardBackgroundColor items-center justify-end gap-3 ">
                    <input
                      type="checkbox"
                      className="cursor-pointer w-4 h-4 checkBoxCustom"
                      checked={isActive}
                      onChange={() => {
                        setIsActive(true);
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                    <span className="font-normal text-base greyColor">
                      Active
                    </span>
                    <input
                      type="checkbox"
                      className=" cursor-pointer w-4 h-4 checkBoxCustom"
                      checked={!isActive}
                      onChange={() => {
                        setIsActive(false);
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                    <span className="font-normal text-base greyColor">
                      Archive
                    </span>
                  </div>
                </div>
              )}
            {filteredTaskList.filter((task) => task[1].is_archived === true)
              .length == 0 &&
              !isActive && (
                <div>
                  <div className="flex py-8 px-6 cardBackgroundColor items-center justify-end gap-3">
                    <input
                      type="checkbox"
                      className="cursor-pointer w-4 h-4 checkBoxCustom"
                      checked={isActive}
                      onChange={() => {
                        setIsActive(true);
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                    <span className="font-normal text-base greyColor">
                      Active
                    </span>
                    <input
                      type="checkbox"
                      className=" cursor-pointer w-4 h-4 checkBoxCustom"
                      checked={!isActive}
                      onChange={() => {
                        setIsActive(false);
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    />
                    <span className="font-normal text-base greyColor">
                      Archive
                    </span>
                  </div>
                </div>
              )}
          </>
        }
      </div>
    </div>
  );
}
